<template>
    <div class="sortable">
        <slot></slot>
    </div>
</template>

<script>
    module.exports = {
        created:function() {

        },
        data:function() {
            return {

            }
        },
        props: {
            handle:{ type:String, default:'.sort-handle' },
            container:{ type:String, default:'' },
            items:{ type:String, default:'' },
            field:{type:String,default:''}
        },
        methods: {

        },
        mounted:function() {
            if(this.container != '') {
                $(this.container).sortable({
                    items:this.items,
                    axis:'y',
                    cursor: 'pointer',
                    handle:this.handle,
                    dropOnEmpty: false,
                    start: function (e, ui) {
                        ui.item.addClass("selected");
                    }.bind(this),
                    stop: function (e, ui) {
                        ui.item.removeClass("selected");
                        if(this.field != '') {
                            $(this.$el).find(this.field).each(function(index) {
                                $(this).val(index);
                            });
                        }
                    }.bind(this)
                });
            }
        }
    }
</script>
